<template>
  <div>
    <div id="select-full-page">
      <div id="main-margin">
        <div id="top-info">
          <div @click="$emit('close')">
            {{ $t('myday.cancel') }}
          </div>
          <span>{{ `${$t('form.select')}` }}</span>
        </div>
        <span id="form-title">{{ `${$t(label)}` }}</span>
  
        <div class="date-type-choice">
          <input
            id="radio-custom"
            v-model="dateType"
            type="radio"
            value="custom"
          >
          <label for="radio-custom">{{ $t('form.customDate') }}</label>
        </div>
        <date-input
          :placeholder="placeholder"
          :name="name"
          :validation="validation"
          :defaultValue="defaultSelected ? defaultSelected.value1 : null"
          :label="$t('form.start_date')"
          :validate="false"
          @add-data="filterDates.startDate = $event.value"
        />
        <date-input
          :placeholder="placeholder"
          :name="name + '2'"
          :validation="validation"
          :label="$t('form.end_date')"
          :defaultValue="defaultSelected ? defaultSelected.value2 : null"
          :validate="false"
          @add-data="filterDates.endDate = $event.value"
        />
  
        <p
          v-if="errorMsg != null"
          class="error-msg"
        >
          {{ $t('errors.' + errorMsg) }}
        </p>
      </div>
      <div class="button-fixed">
        <button
          style="user-select: none"
          class="btn-custom"
          :class="{ disabled: errorMsg }"
          type="button"
          :disabled="errorMsg"
          @click="validateDates(true)"
        >
          {{ $t('form.validate') }}
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
import DateInput from '@/components/GenericComponents/Form/BasicDateInput.vue'
  
export default {
  components: {
    DateInput
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    validation: {
      type: [String, Boolean],
      default: null
    },
    defaultSelected: {
      type: [Object, String],
      default: null
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['dataSelected', 'close'],
  data() {
    return {
      dateType: 'custom',
      filterDates: {
        startDate: '',
        endDate: ''
      },
      errorMsg: null
    }
  },
  watch: {
    dateType() {
      this.checkDates()
    },
    filterDates: {
      handler() {
        this.checkDates()
      },
      deep: true
    }
  },
  mounted() {
    if (typeof this.defaultSelected === 'string') {
      this.dateType = this.defaultSelected
    }
  },
  methods: {
    validateDates(close = false) {
      if (close) {
        this.$emit('close')
      }
  
      let obj = {
        value1: this.filterDates.startDate,
        value2: this.filterDates.endDate
      }
      if (this.dateType !== 'custom') {
        obj = this.dateType
      }
      this.$emit('dataSelected', obj)
    },
    setError() {
      this.errorMsg = 'params_incorrect'
    },
    clearMessage() {
      this.errorMsg = null
    },
    checkDates() {
      if (
        this.dateType === 'custom' &&
        (this.filterDates.startDate === '' ||
          this.filterDates.endDate === '' ||
          this.filterDates.startDate > this.filterDates.endDate)
      ) {
        this.setError()
      } else {
        this.clearMessage()
      }
    }
  }
}
  </script>
  
  <style lang="scss" scoped>
    #select-full-page {
      position: fixed;
      inset: 0;
      z-index: 200;
      background-color: #fff;

      #main-margin {
        margin: 10px 20px 0;
  
        > form {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
  
        #top-info {
          margin-top: 30px;
          margin-bottom: 7px;

          > div {
            position: absolute;
            width: 60px;
            z-index: 40;
            left: 20px;
            padding: 6px 6px 5px 0;
          }

          > span {
            width: 100%;
            font-size: 1.2rem !important;
            text-align: center;
            display: block;
            padding: 0 63px;
            line-height: 18px;
          }
        }

        #form-title {
          font-size: 20px;
        }
      }
  
      .button-fixed {
        position: fixed;
        bottom: 0;
        background-color: white;
        width: 100%;
        padding: 1rem;
      }

      .disabled {
        opacity: 0.4;
        pointer-events: none;
      }
    }
  </style>
  
